import * as React from 'react';
import {useDispatch} from 'react-redux';
import type {ModalComponent} from 'src/types/modal';
import type {ModalType} from 'src/components/modals/modal-root';
import {popModal} from 'src/action-creators/modal';
import BaseModal from 'src/components/modals/base-modal';
import InfoIcon from 'src/images/icons/warning-info-icon.svg';
import DeleteIcon from 'src/images/delete-icon.svg';
import {Header, Paragraph} from 'src/designSystem2021Components/text-v2';
import {Button} from 'src/designSystem2021Components/buttons';
import css from './referral-withdraw.css';


export default function ReferralWithdrawContainer({
  type,
}: {
  type: ModalType | ModalComponent;
}) {
  const dispatch = useDispatch();

  return (
    <BaseModal
      type={type}
      confirmText="Yes"
      abortText="No"
      removeModal={() => dispatch(popModal())}
      className={css.baseModal}
    >
      <div className={css.modalContainer}>
        <div className={css.modalHeader}>
          <Header>
            <InfoIcon /> Withdraw Candidature
          </Header>
          <DeleteIcon />
        </div>
        <div className={css.modalBody}>
          <Paragraph>
            Are you sure you want to withdraw your candidature from this
            referral submission?
          </Paragraph>
        </div>
        <div className={css.modalFooter}>
          <Button>Yes</Button>
          <Button type="tertiary">No</Button>
        </div>
      </div>
    </BaseModal>
  );
}
